import { createContext } from "react";
import { MAX_SELECTED_VALUES_IN_CONDITIONS } from "../conditions.ts";

const SelectionLimitContext = createContext(MAX_SELECTED_VALUES_IN_CONDITIONS);

export default SelectionLimitContext;
